<template>
  <div class="o-saved-for-later">


    <app-navigation :currentSpace="$t('web.saved_rewards.nav_space')" backButton="true"></app-navigation>


    <main class="o-saved-for-later__main">
      <search-bar></search-bar>


      <section class="c-page-header">
        <div class="c-page-header__left">
          <h1 class="c-page-header__left__title">
            <i class="fa fa-heart t-icon-primary-color"></i>
            {{ $t('web.saved_rewards.page_header') }}
          </h1>
        </div>
      </section>


      <section
        v-for          = "item in savedRewards"
        class          = "c-card c-card--saved-reward qa-saved-item"
      >
        <div class="c-card--saved-reward__details">

          <router-link
            v-if  = "item.available"
            :to   = "{ name: 'Single Reward', params: { id: item.ro_id}}"
            class = "c-card--saved-reward__details__img"
          >
            <img v-if="item.image && item.image['350x350']" :src="item.image['350x350']"/>
            <img v-else src="/img/thm350.png" />
          </router-link>

          <span
            v-if  = "!item.available"
            :to   = "{ name: 'Single Reward', params: { id: item.ro_id}}"
            class = "c-card--saved-reward__details__img
                     c-card--saved-reward__details__img--no-hover"
          >
            <img v-if="item.image && item.image['350x350']" :src="item.image['350x350']"/>
            <img v-else src="/img/thm350.png" />
          </span>

          <div class="c-card--saved-reward__details__info">
            <router-link
              v-if  = "item.available"
              :to   = "{ name: 'Single Reward', params: { id: item.ro_id}}"
              class = "c-card--saved-reward__details__info__title
                       t-link
                       qa-saved-item-title"
            >
              {{ item.name }}
            </router-link>

           <span
              v-if  = "!item.available"
              :to   = "{ name: 'Single Reward', params: { id: item.ro_id}}"
              class = "c-card--saved-reward__details__info__title
                       qa-saved-item-title"
            >
              {{ item.name }}
            </span>

            <div v-if="item.available" class="c-card--saved-reward__details__info__points">
              <i class="fa fa-star t-points-icon"></i>
              <vue-numeric
                separator  = ","
                :read-only = "true"
                v-model    = "item.price">
              </vue-numeric>
            </div>

            <div v-if="!item.available" class="c-card--saved-reward__details__info__removed">
              {{ $t('web.saved_rewards.item_unavailabe') }}
            </div>

          </div>
        </div>


        <div class="c-card--saved-reward__buttons">
          <button
            v-on:click = "deleteItem(item.id)"
            :disabled  = "deleteProcessing"
            class      = "c-card--saved-reward__buttons__button
                          c-button
                          t-button-plain
                          qa-remove-saved-item"
          >
            {{ $t('web.saved_rewards.remove_item') }}
          </button>

          <router-link
            v-if  = "item.available"
            :to   = "{ name: 'Single Reward', params: { id: item.ro_id}}"
            class = "c-card--saved-reward__buttons__button c-button t-button-plain"
          >
            {{ $t('web.saved_rewards.go_to_item') }}
          </router-link>
        </div>
      </section>
    </main>


    <app-footer></app-footer>
  </div>
</template>




<script>
import { mapActions, mapGetters } from 'vuex'
import VueNumeric from 'vue-numeric'
import SearchBar from '@/views/components/catalog/SearchBar'

export default {
  name: 'saved-rewards',
  components: {
    'vue-numeric': VueNumeric,
    'search-bar': SearchBar
  },
  data () {
    return {
      deleteProcessing: false
    }
  },
  mounted () {
    this.LOAD_PARTICIPANT()
    this.GET_SAVED_REWARDS()
  },
  computed: {
    ...mapGetters([
      'participant',
      'savedRewards'
    ])
  },
  methods: {
    ...mapActions(['LOAD_PARTICIPANT', 'DELETE_SAVED_REWARDS', 'GET_SAVED_REWARDS']),

    deleteItem: function (id) {
      this.deleteProcessing = true
      this.DELETE_SAVED_REWARDS(id).then(resp => {
        this.deleteProcessing = false
      }).catch(() => {
        this.deleteProcessing = false
      })
    }
  }
}

</script>



// WEBPACK FOOTER //
// SavedRewards.vue?53832bfe